import { ActionTypes } from "./types";
import { ActionTypes as UpdateGoalActionTypes } from '../UpdateGoal/types';
import { getCookie, setCookie } from "../../utils/StorageVariables";

// Load selectedGoalAction from localStorage
const getInitialSelectedGoalAction = () => {
  try {
    const stored = getCookie("selectedGoalAction");
    return stored ? JSON.parse(stored) : false;
  } catch (error) {
    console.error("Error loading selectedGoalAction from localStorage:", error);
    return false;
  }
};

// Helper function to save selectedGoalAction to localStorage
const saveSelectedGoalActionToStorage = (selectedGoalAction) => {
  try {
    if (selectedGoalAction) {
      setCookie("selectedGoalAction", JSON.stringify(selectedGoalAction));
    } else {
      setCookie("selectedGoalAction", null);
    }
  } catch (error) {
    console.error("Error saving selectedGoalAction to localStorage:", error);
  }
};

let INITIAL_STATE = {
  selectedGoalAction: getInitialSelectedGoalAction(),
  toggledSidebar: 'left',
  drawerMenu: false,
  infoSidebar: false,
  isDisabled: false,
  SelectedClient: null,
  isEdit: false,
  isEditId: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ActionTypes.SELECTED_GOAL_ACTION: {
      const newState = {
        ...state,
        selectedGoalAction: action.payload,
      };
      saveSelectedGoalActionToStorage(newState.selectedGoalAction);
      return newState;
    }

    case ActionTypes.SELECTED_GOAL_ACTION_ADD_ACTION: {
      const updatedSelectedGoalAction = {
        ...state.selectedGoalAction,
        goal: {
          ...state.selectedGoalAction.goal,
          actions: [
            ...state.selectedGoalAction.goal.actions,
            action.payload
          ]
        }
      };
      
      const newState = {
        ...state,
        selectedGoalAction: updatedSelectedGoalAction
      };
      
      saveSelectedGoalActionToStorage(newState.selectedGoalAction);
      return newState;
    }

    case ActionTypes.SELECTED_GOAL_ACTION_REMOVE_ACTION: {
      if (!state.selectedGoalAction.goal)
        return state;

      try {
        const updatedSelectedGoalAction = {
          ...state.selectedGoalAction,
          goal: {
            ...state.selectedGoalAction.goal,
            actions: state.selectedGoalAction.goal.actions.filter(item => item.id !== action.payload)
          }
        };
        
        const newState = {
          ...state,
          selectedGoalAction: updatedSelectedGoalAction
        };
        
        saveSelectedGoalActionToStorage(newState.selectedGoalAction);
        return newState;
      } catch (error) {
        console.error('Error removing action from goal', error);
        return state;
      }
    }

    case UpdateGoalActionTypes.UPDATE_GOAL_SUCCESS: {
      // Only update if the goal IDs match
      if (state.selectedGoalAction?.goal?.id === action.payload.goalId) {
        const updatedSelectedGoalAction = {
          ...state.selectedGoalAction,
          goal: {
            ...state.selectedGoalAction?.goal,
            ...action.payload.data
          }
        };
        
        const newState = {
          ...state,
          selectedGoalAction: updatedSelectedGoalAction
        };
        
        saveSelectedGoalActionToStorage(newState.selectedGoalAction);
        return newState;
      }
      return state;
    }

    case ActionTypes.TOGGLE_SIDEBAR_ACTION:
      return {
        ...state,
        toggledSidebar: action.payload,
      };

    case ActionTypes.DRAWER_MENU_ACTION:
      return {
        ...state,
        drawerMenu: action.payload,
      };

    case ActionTypes.TOGGLE_INFO_SIDEBAR_ACTION:
      return {
        ...state,
        infoSidebar: typeof action.payload === 'boolean' ? action.payload : !state.infoSidebar
      };
    case ActionTypes.IS_DISABLED:
      return {
        ...state,
        isDisabled: action.payload,
      };
    case ActionTypes.SELECTED_CLIENT:
      return {
        ...state,
        SelectedClient: action.payload,
      };
    case ActionTypes.IS_EDITING:
      return {
        ...state,
        isEdit: action.payload
      };
    case ActionTypes.IS_EDITING_ID:
      return {
        ...state,
        isEditId: action.payload
      };
    default:
      return state;
  }
};
